var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FE0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20.3396V13.5H0V0Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7204 8.97168L14.8764 9.41837L13.4187 7.80324L13.0096 8.45332L12.7204 8.97168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4638 9.28822L11.7861 9.64511L11.2815 9.9444L12.9094 11.3959L12.4638 9.28822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8836 10.0938L10.125 10.067L9.5394 10.0739L10.2199 12.1289L10.8836 10.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10104 9.99399L8.47969 9.60293L7.95442 9.31545L7.51992 11.417L9.10104 9.99399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6101 9.00868L7.27734 8.38476L6.96249 7.8539L5.54766 9.45001L7.6101 9.00868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83117 7.41456L6.85547 6.73418L6.84779 6.08172L4.80938 6.75528L6.83117 7.41456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9624 5.65234L7.31953 5.08886L7.64915 4.50111L5.52656 4.06583L6.9624 5.65234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94319 4.2098L8.54297 3.89179L9.13259 3.54448L7.49356 2.08301L7.94319 4.2098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49989 3.44492L10.2041 3.46992L10.8824 3.46194L10.183 1.35001L9.49989 3.44492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 3.54419L11.8547 3.93398L12.4291 4.25438L12.8777 2.06192L11.2353 3.54419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6967 4.49081L14.8553 4.02891L13.3756 5.69817L13.0518 5.15215L12.6967 4.49081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5008 6.04147L15.5883 6.72364L13.4809 7.42151L13.4736 6.80801L13.5008 6.04147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8988 6.76583C12.9674 8.27404 11.7967 9.55548 10.2832 9.61876C8.76973 9.68204 7.49356 8.51662 7.43027 7.00314C7.425 6.92404 7.425 6.84494 7.43027 6.76056C7.49883 5.25236 8.775 4.08165 10.2832 4.14494C11.7018 4.21349 12.8355 5.34728 12.8988 6.76583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16ZM16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0Z",
    fill: "#D7D7D7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryTw);
export default __webpack_public_path__ + "static/media/country-tw.c2882864.svg";
export { ForwardRef as ReactComponent };